<template>
  <v-expansion-panels
    style="margin-bottom: 10px"
    :value="commentPanel"
    @input="$emit('update:commentPanel', $event)"
  >
    <v-expansion-panel>
      <v-expansion-panel-header disable-icon-rotate>
        Dodaj napomenu
        <template v-slot:actions>
          <v-icon> mdi-receipt-text-outline </v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row dense style="margin-top: -1rem">
          <v-col cols="12">
            <v-textarea
              outlined
              :value="note"
              @input="$emit('update:note', $event)"
              label="Napomena"
              rows="3"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: 'CommentPanel',
  props: {
    commentPanel: {
      type: Array,
      default: () => []
    },
    note: {
      type: String,
      default: ''
    }
  }
}
</script>
